package com.vamvisions.main.layout

import com.vamvisions.main.core.domain.preferences.ColorScheme
import com.vamvisions.main.core.domain.preferences.Language
import com.vamvisions.main.core.presentation.navigation.Route

/**
 * What every page passes to [PageLayout]: the shell state and the callbacks the header needs.
 * [onReplace] shows another route in place of the current history entry. [onNavigateToSection] opens
 * a route at the element whose id is the given fragment.
 */
data class PageChrome(
    val currentRoute: Route,
    val colorScheme: ColorScheme,
    val language: Language,
    val onNavigate: (Route) -> Unit,
    val onNavigateToSection: (Route, String) -> Unit,
    val onReplace: (Route) -> Unit,
    val onToggleColorScheme: () -> Unit,
    val onLanguageChange: (Language) -> Unit,
)
